import React from 'react';
import { motion } from 'framer-motion';

// Mock data for Instagram posts
const mockPosts = [
  {
    id: '1',
    imageSrc: '/assets/Insta 1.png',
    postLink: 'https://www.instagram.com/p/DUaxzAfgN1S/',
    mediaType: 'photo',
  },
  {
    id: '2',
    imageSrc: '/assets/Insta 3.png',
    postLink: 'https://www.instagram.com/jlescolanautica/reel/DEqIPtpxkTv/',
    mediaType: 'carousel',
  },
  {
    id: '3',
    imageSrc: '/assets/Insta 2.png',
    postLink: 'https://www.instagram.com/p/DT-v9AVgLTU/',
    mediaType: 'video',
  },
  {
    id: '4',
    imageSrc: '/assets/Insta 4.png',
    postLink: 'https://www.instagram.com/p/DTwIyD9gFtL/',
    mediaType: 'photo',
  },
  {
    id: '5',
    imageSrc: '/assets/Insta 5.webp',
    postLink: 'https://www.instagram.com/p/DUQ_O_CkUm3/',
    mediaType: 'video',
  },
  {
    id: '6',
    imageSrc: '/assets/Insta 6.webp',
    postLink: 'https://www.instagram.com/p/DEYMYKJR9Zz/',
    mediaType: 'carousel',
  },
];

const InstagramIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path
      d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
    />
  </svg>
);

const PhotoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M10.5 8.5a.5.5 0 0 0 0-1H5.5a.5.5 0 0 0 0 1h5zM9 1.5a1.5 1.5 0 0 0-1.5 1.5H6a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5H9.5A1.5 1.5 0 0 0 9 1.5zM4 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4z" />
  </svg>
);

const VideoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M8 5v14l11-7z"/>
  </svg>
);

const CarouselIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h9A1.5 1.5 0 0 1 13 2.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 1 11.5v-9z"/>
    <path d="M4.5 0A1.5 1.5 0 0 1 6 1.5h9A1.5 1.5 0 0 1 16 3v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4.5 12V0z" opacity="0.7"/>
  </svg>
);


interface InstagramPostCardProps {
  imageSrc: string;
  postLink: string;
  mediaType: 'photo' | 'video' | 'carousel';
}

const InstagramPostCard: React.FC<InstagramPostCardProps> = ({ imageSrc, postLink, mediaType }) => {
  const MediaIcon = mediaType === 'video' ? VideoIcon : mediaType === 'carousel' ? CarouselIcon : PhotoIcon;

  return (
    <motion.a
      href={postLink}
      target="_blank"
      rel="noopener noreferrer"
      className="relative block aspect-[9/16] rounded-lg overflow-hidden group shadow-lg border border-gold/50"
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
    >
      <img src={imageSrc} alt={`Instagram ${mediaType}`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Instagram Icon */}
      <InstagramIcon className="absolute bottom-3 left-3 w-6 h-6 text-white opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Media Type Icon */}
      <MediaIcon className="absolute top-3 right-3 w-6 h-6 text-white opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
    </motion.a>
  );
};

const InstagramFeedSection: React.FC = () => {
  return (
    <section id="instagram-feed" className="bg-background py-24 sm:py-32">
      <div className="container mx-auto px-6 lg:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-primary mb-12"
        >
          Nosso <span className='text-gold-shimmer'>Instagram</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 max-w-6xl mx-auto"
        >
          {mockPosts.map((post) => (
            <InstagramPostCard key={post.id} {...post} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default InstagramFeedSection;